import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.scss']
})
export class ErrorPageComponent implements OnInit {

  constructor(
      private route: ActivatedRoute,
        private router: Router) { }

  ngOnInit(): void {
  }

  routeTo(path: any) {
    this.router.navigate([path]);
  }

}
